var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#344054;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.33px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.5,
    y: 13,
    width: 20,
    height: 20
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "featured") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.2,30.4H18.1a.6.6,0,0,1-.1-.4c0-.2.2-.3.6-.7L26,21.7c.4-.3.5-.5.7-.5h.6c.2,0,.3.2.7.5l3.4,3.4v1.1m-4.2,4.2a5.9,5.9,0,0,0,2.7-.3,3.4,3.4,0,0,0,1.2-1.2,5.9,5.9,0,0,0,.3-2.7m-4.2,4.2H19.8a5.9,5.9,0,0,1-2.7-.3,3.4,3.4,0,0,1-1.2-1.2,5.9,5.9,0,0,1-.3-2.7V18.8a5.9,5.9,0,0,1,.3-2.7,3.4,3.4,0,0,1,1.2-1.2,5.9,5.9,0,0,1,2.7-.3h7.4a5.9,5.9,0,0,1,2.7.3,3.4,3.4,0,0,1,1.2,1.2,5.9,5.9,0,0,1,.3,2.7v7.4m-9.2-6.8a1.8,1.8,0,0,1-1.8,1.8,1.8,1.8,0,0,1-1.7-1.8,1.8,1.8,0,0,1,1.7-1.7A1.8,1.8,0,0,1,22.2,19.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverImage);
export default __webpack_public_path__ + "static/media/cover_image.221370d5557d128d62b392af05f2bf13.svg";
export { ForwardRef as ReactComponent };